import React from "react";

import DashboardCard from "../Common/DashboardCard";
import SectionHeader from "../Common/SectionHeader";
import WorkshopCard from "./WorkshopCard";

// Pass workshops already run through mapWorkshopToCard()
export default function WorkshopsCard({ workshops = [], onViewAll, onAction }) {
    return (
        <DashboardCard>
            <SectionHeader title="Workshops" actionText="View All" onAction={onViewAll} />

            {workshops.length === 0 ? (
                <p style={{ color: "#94A3B8", fontSize: 14 }}>
                    No workshops scheduled right now.
                </p>
            ) : (
                workshops.map((workshop) => (
                    <WorkshopCard
                        key={workshop.id}
                        {...workshop}
                        onAction={() => onAction?.(workshop.id)}
                    />
                ))
            )}
        </DashboardCard>
    );
}
